import React from 'react';
import PaymentDetails from './../../components/PaymentDetails';


const Payment = () => {
  return (
      <PaymentDetails />
  );
}

export default Payment;